import React, { useState, useEffect } from "react";
import styles from "./modals.module.scss";
import { calendarIcon, chevronBottom } from "base/SVG";
import classNames from "classnames";
import Button from "components/primary-button/button";
import Select from "components/select/select";
import DateInput from "components/date-input/date-input";

export default function SocialsConfirm({ setModal, user, updateSocials, updatingSocials }) {

  const [social_media_acc, setSocialMediaValue] = useState("");

  return (
    <>
      <div className={classNames(styles["modal__title"], styles["mid"])}>
        <h4>Complete Profile</h4>
        <p className="sm">
          Please complete your profile to continue using the platform. Confirm your social account to proceed.
        </p>
      </div>
      <div className={styles["modal__col"]}>
        <div className={styles["input__outer"]}>
          <p className="sm">Social Account for Communications</p>
          <div className={styles["select"]}>
            <input
              type="text"
              placeholder={"Discord/Telegram/X account"}
              onChange={(e) => setSocialMediaValue(e.target.value)}
              id="social_media_acc"
              value={social_media_acc}
            />
          </div>
        </div>
      </div>
      <div className={styles["modal__foot"]}>
        <Button
          text={"Update"}
          type={"primary"}
          style={{ width: "100%" }}
          onClick={() => updateSocials(social_media_acc)}
          disabled={updatingSocials}
        />
      </div>
    </>
  );
}
